/** venture/VentureEmbed.tsx — 올댓벤처스 어드민 「업무 관리 › 진행현황 (벤처투자유형)」 안에 띄우는 로움 벤처인증 화면 (2026-10-17)
 *  지도사 「로움파트너스에서 보이는 화면 · 구성 · 기능이랑 동일해야지 — 여기서도 되고 로움에서도 되게」
 *  · allthatventures.com/rv/ (같은 출처 iframe) → 로움 빌드의 이 화면만 뜬다(index.js) · 화면은 로움 화면 한 벌(Venture.tsx)
 *  · 로그인은 올댓벤처스 어드민 토큰(atv_token)을 그대로 — 서버(services/ventureOffice)가 올댓벤처스 조합만 보이고 고치게 한다
 */
import React from 'react';
import Venture from './Venture';

function hasAtvLogin(): boolean {
  try {
    const t = localStorage.getItem('atv_token');
    if (!t) return false;
    localStorage.setItem('token', t);   // 화면이 쓰는 토큰 칸(이 출처 = 올댓벤처스 — 로움 로그인과 섞이지 않는다)
    return true;
  } catch {
    return false;
  }
}

interface State { err: string }
class Guard extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { err: '' };
  static getDerivedStateFromError(e: Error): State { return { err: e.message || '화면 오류' }; }
  render() {
    if (this.state.err) return <div style={{ padding: 40, fontSize: 14, color: '#B91C1C' }}>화면을 그리지 못했습니다 — 새로고침해 주세요 ({this.state.err})</div>;
    return this.props.children;
  }
}

export default function VentureEmbed() {
  if (!hasAtvLogin()) {
    return <div style={{ padding: 40, fontSize: 14, color: '#374151' }}>올댓벤처스 어드민에 로그인한 뒤 「진행현황 (벤처투자유형)」 메뉴에서 열어 주세요.</div>;
  }
  return <Guard><Venture me={null} onBack={() => { /* 어드민 메뉴가 홈 */ }} /></Guard>;
}
